import { en_GB } from './en_GB';
import { ru_RU } from './ru_RU';
export var UIKIT_PRODUCT_LOCALES = {
  'en-GB': en_GB,
  'ru-RU': ru_RU
};